import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=e2a32568&scoped=true"
import script from "./PersonnelList.vue?vue&type=script&lang=js"
export * from "./PersonnelList.vue?vue&type=script&lang=js"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&id=e2a32568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a32568",
  null
  
)

export default component.exports